import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"
import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"
import { rialToToman } from "utils/generalUtils"
import { PremiumPlan } from "types/premium.types"
import { IRT } from "constants/index"

interface PremiumPlanProps extends PremiumPlan {
  onClick: () => void;
}

export default function PremiumPlanCard(props: PremiumPlanProps) {
  const { name, price, initialPrice, monthlyPrice, onClick } = props

  const { t } = useTranslation()

  return (
    <Container onClick={onClick}>
      <Stack gap="4px">
        <Title>{name}</Title>
        {monthlyPrice !== price ? <MonthlyPrice className="farsi-digits">
          {t("premium.monthly")} {rialToToman(monthlyPrice)} {t(`currency.${IRT}`)}
        </MonthlyPrice> : null}
      </Stack>
      <Stack>
        <Stack direction="row" alignItems="center" gap="6px">
          {monthlyPrice !== price ? <InitialPrice className="farsi-digits">
            {rialToToman(initialPrice)} {t(`currency.${IRT}`)}
          </InitialPrice> : null}
        </Stack>
        <Stack direction="row" alignItems="center" gap="6px">
          <Price className="farsi-digits">{rialToToman(price)}</Price>
          <Currency>{t(`currency.${IRT}`)}</Currency>
        </Stack>
      </Stack>
    </Container>
  )
}

const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "74px",
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "10px 16px",
  marginBottom: "12px",
  borderRadius: "8px",
  border: `1px solid ${theme.palette.gray["7"]}`
}))

const Title = styled(Typography)(({ theme }) => ({
  fontSize: "1.5rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))

const Price = styled("span")(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 500,
  color: theme.palette.gray["15"]
}))

const InitialPrice = styled("span")(({ theme }) => ({
  fontSize: "1rem",
  color: theme.palette.gray["12"],
  marginLeft: "auto",
  textDecoration: "line-through"
}))

const MonthlyPrice = styled("span")(({ theme }) => ({
  fontSize: "1.3rem",
  color: theme.palette.gray["12"]
}))

const Currency = styled("span")(({ theme }) => ({
  fontSize: "0.9rem",
  color: theme.palette.gray["12"]
}))
